import { render, staticRenderFns } from "./modal-notificacion.vue?vue&type=template&id=a2aa0920&scoped=true&"
import script from "./modal-notificacion.vue?vue&type=script&lang=js&"
export * from "./modal-notificacion.vue?vue&type=script&lang=js&"
import style0 from "./modal-notificacion.vue?vue&type=style&index=0&id=a2aa0920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aa0920",
  null
  
)

export default component.exports